import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { firestore } from "../firebase";

const MAX_SUBMISSIONS = 5;
const WINDOW_MS = 60 * 60 * 1000;
let cachedIp;

async function getClientIp() {
  if (cachedIp) return cachedIp;

  try {
    const response = await fetch("https://api.ipify.org?format=json");
    if (response.ok) cachedIp = (await response.json()).ip || "unknown";
  } catch {
    cachedIp = "unknown";
  }

  return cachedIp || "unknown";
}

export async function sendContactMessage({ from, subject, text }) {
  const ip = await getClientIp();
  const ipKey = encodeURIComponent(ip);
  const rateLimitRef = doc(firestore, "Mail", "RateLimits", "entries", ipKey);
  const messageRef = doc(
    firestore,
    "Mail",
    "Message",
    "entries",
    crypto.randomUUID(),
  );
  const now = Date.now();

  await runTransaction(firestore, async (transaction) => {
    const snapshot = await transaction.get(rateLimitRef);
    const rateLimit = snapshot.exists() ? snapshot.data() : {};
    const windowStarted = rateLimit.windowStarted?.toMillis?.() || 0;
    const sameIpWindow = rateLimit.ip === ip && now - windowStarted < WINDOW_MS;
    const submissionCount = sameIpWindow
      ? Number(rateLimit.submissionCount || 0)
      : 0;

    if (sameIpWindow && submissionCount >= MAX_SUBMISSIONS) {
      const error = new Error("Message limit exceeded. Try again later.");
      error.status = 429;
      throw error;
    }

    transaction.set(rateLimitRef, {
      ip,
      lastSubmission: serverTimestamp(),
      submissionCount: submissionCount + 1,
      windowStarted: sameIpWindow ? rateLimit.windowStarted : serverTimestamp(),
    });
    transaction.set(messageRef, {
      ip,
      createdAt: serverTimestamp(),
      from: from.trim(),
      subject: subject.trim(),
      text: text.trim(),
    });
  });
}
